import { render, staticRenderFns } from "./MyFiles.vue?vue&type=template&id=05f7bc4b&scoped=true"
import script from "./MyFiles.vue?vue&type=script&lang=js"
export * from "./MyFiles.vue?vue&type=script&lang=js"
import style0 from "./MyFiles.vue?vue&type=style&index=0&id=05f7bc4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f7bc4b",
  null
  
)

export default component.exports